import {
  IconName,
  PreviewType,
  TableDocumentPreviewDocument
} from './TableDocumentPreview.types'

type HasUuid = {
  uuid: string
}

const contentTypeByPattern: [RegExp, PreviewType][] = [
  [/^image\//, 'image'],
  [/^video\//, 'video'],
  [/^audio\//, 'audio'],
  [/^application\/pdf/, 'pdf'],
  [/^application\/vnd\.ms-excel/, 'excel'],
  [
    /^application\/vnd\.openxmlformats-officedocument\.spreadsheetml\.sheet/,
    'excel'
  ]
]

export function getContentType(doc: TableDocumentPreviewDocument): PreviewType {
  const fallbackType = 'file'
  const contentType = (doc.content_type ?? '').toLowerCase()
  if (!contentType) return fallbackType
  const match = contentTypeByPattern.find(([re]) => re.test(contentType))
  return match ? match[1] : fallbackType
}

export const previewIcons: Record<PreviewType, IconName> = {
  image: 'ImageFile',
  video: 'VideoFile',
  audio: 'AudioFile',
  pdf: 'PDFFile',
  excel: 'ExcelFile',
  file: 'File'
}

export function isValidDocument(document: unknown): document is HasUuid {
  if (
    document !== null &&
    document !== undefined &&
    typeof document === 'object' &&
    !Array.isArray(document)
  ) {
    return (
      'uuid' in document &&
      typeof document.uuid === 'string' &&
      document.uuid.trim() !== ''
    )
  }
  return false
}

export function getMostRecentDocument(
  documents: TableDocumentPreviewDocument[]
): TableDocumentPreviewDocument | null {
  if (!Array.isArray(documents)) return null
  const valid = documents.filter(isValidDocument)
  if (valid.length === 0) return null
  const withDate = valid.filter((d) => d.date_creation_row != null)
  if (withDate.length > 0) {
    const sorted = [...withDate].sort((a, b) => {
      const aVal = a.date_creation_row ?? ''
      const bVal = b.date_creation_row ?? ''
      return bVal.localeCompare(aVal)
    })
    return sorted[0]
  }
  return valid[0]
}
